/* ===========================================================================
 * MAAHI — Product page video behaviour
 * - Autoplays (muted) when the video scrolls into view
 * - Pauses automatically when it scrolls out of view
 * - Loops continuously
 * - Tap / click anywhere on the video toggles pause / play (no visible
 *   button). A manual pause is remembered — scrolling won't auto-resume
 *   until the user taps the video to play again.
 * =========================================================================== */
(function () {
  function isProductVideo(video) {
    return !!video.closest('.product-media, product-information, .product-information, media-gallery');
  }

  function bind(video) {
    if (video.dataset.maahiVideoBound === '1') return;
    if (!isProductVideo(video)) return;
    video.dataset.maahiVideoBound = '1';

    /* Ensure muted autoplay is allowed + looping + inline on iOS. */
    video.muted = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.removeAttribute('controls');

    var userPaused = false;

    /* Tap / click the video itself to toggle pause / play — no button shown. */
    video.style.cursor = 'pointer';
    video.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        userPaused = false;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        userPaused = true;
        video.pause();
      }
    });

    /* Play when in view, pause when out — respecting a manual pause. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.5) {
              if (!userPaused) {
                var p = video.play();
                if (p && p.catch) p.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.5] }
      );
      io.observe(video);
    } else {
      video.play().catch(function () {});
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('video').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  /* Catch videos injected later (gallery swaps, variant changes, etc.). */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'VIDEO') bind(n);
          else scan(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
